export default __webpack_public_path__ + "static/media/TMP_Logo.f2d5284b.png";